import React, { useState, useEffect } from "react";
import DatePicker from "../DatePicker/reactDate";
import { Form, Button, Row, Col } from "react-bootstrap";
import "../../style.scss";
import _ from "lodash";
import { vipStyle } from "utils/common";

import moment from "moment";
import {
  DAY_MONTH_YEAR,
  YEAR_MONTH_DAY_2,
  addBusinessDays
} from "constants/date";
import { ValidateNRICData, INDEX } from "constants/appointment";

import {
  getAppointmentBooking,
  getTimeSlots,
  getAppointmentAvailableDates
} from "services/api-service";

import { batch, useDispatch, useSelector } from "react-redux";

import {
  changeAttendingWithAnother,
  changeSelectedDate,
  changeSelectedService,
  changeSelectedTimeSlot,
  changeAnotherNric,
  changeAnotherSelectedTimeSlot
} from "redux/appointmentBooking";

import {
  EARLIEST_APPOINTMENT_AVAILABLE,
  SELECT_DATE,
  SELECT_SERVICE_CENTER,
  ARE_YOU_VISITING_US_WITH_ANOTHER_PERSON
} from "constants/text";

import {
  Radio,
  RadioList,
  Disclaimer,
  HomeButton,
  NextButton,
  InputText,
  SeparatorLine,
  CommonButton
} from "../CommonUI";

const { NRIC_INDEX } = INDEX;

const DEFAULT_SUGGESTED_SLOT_DAY = 99;
const YES = "1";
const NO = "0";
const ZERO = 0;
const MINUTES = "minutes";

export default function AppointmentBookingForm({
  onOpenModal,
  onSubmit,
  onNavigate
}) {
  const dispatch = useDispatch();

  const {
    attendingWithAnother,
    selectedDate,
    selectedService,
    selectedTimeSlot,
    selectedApptType,
    registeredAppointmentId,
    anotherNric
  } = useSelector((state) => state.appointmentBooking);

  const { isCrps, isExperience } = useSelector((state) => state.services);

  const { nric } = useSelector((state) => state.appointment);
  const { isLoading } = useSelector((state) => state.loading);

  const [acceptTermAndCondition, setAcceptTermAndCondition] = useState(false);
  const [serviceLocations, setServiceLocations] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [validateErrors, setValidateErrors] = useState([]);
  const [validated, setValidated] = useState(false);
  const [suggestedSlotDay, setSuggestedSlotDay] = useState(
    DEFAULT_SUGGESTED_SLOT_DAY
  );
  const [availableDates, setAvailableDates] = useState([]);
  const [selectedDateLocal, setSelectedDateLocal] = useState(null);

  // const tomorrowDate = addBusinessDays(new Date(), 1);

  const onChangeDate = (date) => {
    dispatch(changeSelectedDate(date));
    setSelectedDateLocal(moment());
  };

  const onChangeRadio = (e) => {
    batch(() => {
      dispatch(changeSelectedTimeSlot({ value: "", label: "" }));
      dispatch(changeAnotherSelectedTimeSlot({ value: "", label: "" }));
      dispatch(changeAnotherNric(""));
      dispatch(changeAttendingWithAnother(e.target.value));
    });
  };

  const handleSelectedService = (id, displayText, addressText) => {
    if (id == selectedService.value) return;
    console.log("timeSlots.length", timeSlots.length);
    if (timeSlots.length === 0) {
      dispatch(
        changeSelectedDate(
          availableDates.length > 0
            ? moment(availableDates[0]).format(YEAR_MONTH_DAY_2)
            : moment().add(1, "day").format(YEAR_MONTH_DAY_2)
        )
      );
    }

    batch(() => {
      // dispatch(changeSelectedDate(null));
      dispatch(changeSelectedTimeSlot({ value: "", label: "" }));
      dispatch(
        changeSelectedService({
          value: id,
          label: displayText,
          address: addressText
        })
      );
    });
  };
  const handleSelectedTimeSlots = (id, scheduleDate) => {
    if (attendingWithAnother !== YES) {
      dispatch(changeSelectedTimeSlot({ value: id, label: scheduleDate }));
      return;
    }
    if (getNextTimeSlot(id)) {
      batch(() => {
        dispatch(changeSelectedTimeSlot({ value: id, label: scheduleDate }));
        dispatch(changeAnotherSelectedTimeSlot(getNextTimeSlot(id)));
      });
    }
  };

  const getNextTimeSlot = (timeSlotId) => {
    const index = timeSlots.findIndex((x) => x.id === timeSlotId);
    const nextTimeSlot = timeSlots[index + 1];

    if (_.isEmpty(nextTimeSlot)) {
      return null;
    }

    const curTimeSlot = timeSlots[index];
    if (
      moment(nextTimeSlot.date_time).isSame(
        moment(curTimeSlot.date_time).add(
          curTimeSlot.TIMESLOT_INTERVAL,
          MINUTES
        )
      )
    ) {
      return { value: nextTimeSlot.id, label: nextTimeSlot.schedule_dt };
    }

    return null;
  };

  useEffect(() => {
    console.log("v18");
    getAppointmentBookingInitData();
  }, []);

  const getAppointmentBookingInitData = async () => {
    const response = await getAppointmentBooking(selectedApptType.value);

    response.data.data.serviceLocations &&
      setServiceLocations(response.data.data.serviceLocations);

    const suggestAvailableLocationId =
      response.data.data.suggestedSlotDayAndLocation[0]
        .suggest_availabe_location_id;

    const suggestAvailableSlotDay =
      response.data.data.suggestedSlotDayAndLocation[0]
        .suggest_avaialbe_slot_day;

    setSuggestedSlotDay(suggestAvailableSlotDay);

    if (suggestAvailableLocationId) {
      const suggestedLocation = response.data.data.serviceLocations.filter(
        ({ id }) => id === suggestAvailableLocationId
      );
      suggestedLocation.length > 0 &&
        dispatch(
          changeSelectedService({
            value: suggestedLocation[0].id,
            label: suggestedLocation[0].web_disp_text,
            address: suggestedLocation[0].address_text
          })
        );
    }
    // getAvailableDates();
  };

  useEffect(() => {
    getAppointmentAvailableDates(
      selectedApptType.value,
      selectedService.value
    ).then((res) => {
      const { data: availableDates } = res;
      if (!availableDates.data) return;

      setAvailableDates(
        availableDates.data.length > 0
          ? availableDates.data.map((date) => new Date(date.apptDate))
          : []
      );

      console.log(
        "changeSelectedDate",
        availableDates.data.length > 0
          ? moment(availableDates.data[0].apptDate).format(YEAR_MONTH_DAY_2)
          : null
      );

      dispatch(
        changeSelectedDate(
          availableDates.data.length > 0
            ? moment(availableDates.data[0].apptDate).format(YEAR_MONTH_DAY_2)
            : null
        )
      );
      setSelectedDateLocal(
        availableDates.data.length > 0
          ? moment(availableDates.data[0].apptDate)
          : null
      );
    });
    // getTimeSlotsDataByService();
  }, [selectedApptType.value, selectedService.value, dispatch]);

  // const getTimeSlotsDataByService = async () => {
  //   if (availableDates.length === 0) return;

  //   console.log("###2", moment(availableDates[0]).format(YEAR_MONTH_DAY_2));

  //   const response = await getTimeSlots(
  //     moment(availableDates[0]).format(YEAR_MONTH_DAY_2),
  //     selectedService.value,
  //     selectedApptType.value
  //   );

  //   setTimeSlots(response.data.data || []);
  // };

  const getTimeSlotsDataByDate = async () => {
    console.log("###1", selectedDate);
    if (selectedDate == null) return;

    try {
      dispatch(changeSelectedTimeSlot({ value: "", label: "" }));
      setTimeSlots([]);

      const response = await getTimeSlots(
        moment(selectedDate).format(YEAR_MONTH_DAY_2),
        selectedService.value,
        selectedApptType.value
      );
      setTimeSlots(response.data.data);
    } catch(e) {
      console.log("***", e)
      // setTimeSlots([]);
    }

  };

  useEffect(() => {
    console.log("selectedDateLocal", selectedDateLocal);
    if (selectedDateLocal != null) {
      getTimeSlotsDataByDate();
    }
  }, [selectedDateLocal]);

  const onConfirm = () => onOpenModal && onOpenModal();

  const handleOnSubmit = (e) => {
    e.preventDefault();

    console.log("attendingWithAnother", attendingWithAnother);

    if (attendingWithAnother === YES && !isCrps) {
      const validateErrors = ValidateNRICData(anotherNric, nric);
      setValidateErrors(validateErrors);

      (!e.currentTarget.checkValidity() || validateErrors.length === ZERO) &&
        e.stopPropagation();

      setValidated(true);
      if (validateErrors.length !== ZERO) {
        window.scrollTo(0, 0);
        return;
      }
    }

    onSubmit && onSubmit();
  };

  const onChangeNric = (e) =>
    dispatch(changeAnotherNric(e.target.value.toUpperCase()));

  const goToSummary = () => onNavigate && onNavigate();

  const disabled =
    !isLoading &&
    selectedService &&
    selectedTimeSlot.value &&
    acceptTermAndCondition
      ? false
      : true;

  // console.log("**1", selectedService, selectedDate);

  // let timeslotWithAnother = [];
  // if (timeSlots.length > 0 && attendingWithAnother === YES) {
  //   timeslotWithAnother = timeSlots.filter((x) => {
  //     if (getNextTimeSlot(x.id)) {
  //       return true;
  //     }
  //     return false;
  //   });
  //   console.log("timeslotWithAnother", timeslotWithAnother);
  // }

  return (
    <div className="row">
      <Form noValidate validated={validated} onSubmit={handleOnSubmit}>
        <div className="offset-xl-1 col-xl-10">
          {!isCrps && !isExperience && (
            <>
              <div className="p-3">
                <div>{ARE_YOU_VISITING_US_WITH_ANOTHER_PERSON}</div>
                <div>
                  If the person does not have enquiries, please select “No”.
                </div>
                <div className="col-5 col-sm-3 col-md-2">
                  <Form.Group>
                    <div className="d-flex mt-2">
                      <Radio
                        id="isAnotherPerson"
                        label="Yes"
                        value={YES}
                        onChange={onChangeRadio}
                        checked={Boolean(Number(attendingWithAnother))}
                      />
                      <Radio
                        id="isAnotherPerson"
                        label="No"
                        value={NO}
                        onChange={onChangeRadio}
                        checked={!Boolean(Number(attendingWithAnother))}
                      />
                    </div>
                  </Form.Group>
                </div>
                {attendingWithAnother == YES && (
                  <Form.Group className="col-10 col-sm-8 col-md-6 mt-3">
                    <InputText
                      label=" NRIC / FIN / Passport number"
                      type="text"
                      placeholder="NRIC / FIN / Passport number"
                      value={anotherNric}
                      onChange={onChangeNric}
                      isInvalid={validateErrors[NRIC_INDEX]}
                      errorMessage={validateErrors[NRIC_INDEX]}
                    />
                  </Form.Group>
                )}
              </div>
              <SeparatorLine />
            </>
          )}

          <div className="p-3">
            <div
              className="my-5"
              ref={(n) => vipStyle(n, { "margin-top": 0, "margin-bottom": 0 })}
            >
              <div>
                These are the earliest time slots available for you.
                <br />
                Please choose your preferred time.
                <br />
                If you would like to choose your preferred service centre and
                time, please proceed below.
              </div>

              <br />
              <div>{SELECT_SERVICE_CENTER}</div>
              <div className="mt-2">
                <Row>
                  <RadioList style={{ paddingTop: 0 }}>
                    {serviceLocations.map(
                      ({
                        id,
                        web_disp_text: displayText,
                        address_text: addressText
                      }) => (
                        <Col lg={4} md={4} className="p-0 my-1" key={id}>
                          <Radio
                            id="serviceLocation"
                            label={displayText}
                            value={id}
                            onChange={() =>
                              handleSelectedService(
                                id,
                                displayText,
                                addressText
                              )
                            }
                            checked={id === selectedService.value}
                          />
                        </Col>
                      )
                    )}
                  </RadioList>
                </Row>
              </div>
            </div>
            <div className={"mt-2"}>
              <Row style={{ padding: 12 }}>
                {selectedDate == null && (
                  <Col lg={10} md={12} className="p-0 my-1">
                    <div style={{ color: "#eb3c36" }}>
                      All dates are fully booked for this service centre. You
                      may want to choose another service centre.
                    </div>
                  </Col>
                )}
                {selectedDate != null && (
                  <Col lg={4} md={4} className="p-0 my-1">
                    <DatePicker
                      // className="mb-5 max-with-250"
                      label={SELECT_DATE}
                      value={selectedDate}
                      onChange={onChangeDate}
                      includeDates={availableDates}
                    />
                  </Col>
                )}
              </Row>
            </div>
            {/* {suggestedSlotDay !== 0 && (
              <Row className="mb-0">
                <Col xs={11}>{EARLIEST_APPOINTMENT_AVAILABLE}</Col>
              </Row>
            )} */}
            {/* {selectedService.label && (
              <Row className="mb-0">
                <Col className="my-2">
                  <h4 className="cmp-teaser__title">{selectedService.label}</h4>
                </Col>
              </Row>
            )} */}
            {/* <Row className="mb-0 mt-2">
              <Col xs={5} md={3} lg={2} className="mb-2">
                <div className="border center p-1 bg-light-gray">
                  {moment(selectedDate).format(DAY_MONTH_YEAR)}
                </div>
              </Col>
            </Row> */}
            {selectedDate != null && (
              <>
                <Row style={{ padding: 12, paddingBottom: 0 }}>Time</Row>
                <Row className="mb-0">
                  {timeSlots.length > 0 ? (
                    timeSlots.map(({ id, schedule_dt: scheduleDate }) =>
                      attendingWithAnother === YES ? (
                        getNextTimeSlot(id) && (
                          <Col
                            xs={12}
                            sm={6}
                            md={4}
                            lg={3}
                            className="mt-2"
                            key={id}
                          >
                            <RadioList>
                              <Radio
                                id="serviceTime"
                                label={scheduleDate}
                                onChange={() =>
                                  handleSelectedTimeSlots(id, scheduleDate)
                                }
                                checked={id === selectedTimeSlot.value}
                              />
                            </RadioList>
                          </Col>
                        )
                      ) : (
                        <Col
                          xs={12}
                          sm={6}
                          md={4}
                          lg={3}
                          className="mt-2"
                          key={id}
                        >
                          <RadioList>
                            <Radio
                              id="serviceTime"
                              label={scheduleDate}
                              onChange={() =>
                                handleSelectedTimeSlots(id, scheduleDate)
                              }
                              checked={id === selectedTimeSlot.value}
                            />
                          </RadioList>
                        </Col>
                      )
                    )
                  ) : (
                    <Col>
                      There is no available time slots for the date. <br />
                      Please choose another date.
                    </Col>
                  )}
                </Row>
              </>
            )}
            <div className="mt-4">
              <Disclaimer
                onChange={() =>
                  setAcceptTermAndCondition(!acceptTermAndCondition)
                }
                checked={acceptTermAndCondition}
              />
            </div>
          </div>
        </div>
        <div className="form-footer flex-sm-column flex-sm-column-reverse flex-md-row flex-column-reverse justify-content-sm-between justify-content-start align-items-sm-center align-items-end">
          <div className="mt-2 mobile-w-100 mobile-m-lr-0">
            <HomeButton onClick={onConfirm} />
          </div>

          <div className="d-flex flex-md-row flex-column-reverse mobile-w-100">
            {registeredAppointmentId && (
              <div style={{ marginRight: window.innerWidth <= 990 ? 0 : 10 }}>
                <div
                  className={`mt-2 mobile-m-lr-0 mobile-w-100 ${
                    registeredAppointmentId ? "mx-0" : "mx-sm-3 mx-md-3 mx-lg-3"
                  }`}
                >
                  <CommonButton
                    onClick={goToSummary}
                    leftOrRight={"right"}
                    text={"Back to summary"}
                  />
                </div>
              </div>
              // <Button
              //   className="btn cmp-button pbs-style--primary rounded-pill mt-2 mx-2 mx-sm-3 mx-md-3 mx-lg-3"
              //   onClick={goToSummary}
              // >
              //   Back To Summary
              // </Button>
            )}
            <div
              className={`mobile-m-lr-0 mt-2 ${
                registeredAppointmentId ? "mx-0" : "mx-sm-0 mx-md-3 mx-lg-3"
              }`}
            >
              <NextButton text="CONFIRM" disabled={disabled} type="submit" />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}
